import {
  DocumentCategory,
  getDocumentCategory,
  type IViewerDocument,
} from '@orn/shared-web/components/DocumentViewer/documentUtils';
import { FileIcon, ImageIcon, MailIcon } from '@orn/shared-web/icons';
import { cx } from '@orn/shared-web/utils/cx';
import * as React from 'react';

/** The same glyph per category the viewer's rail uses for its group headers. */
const CATEGORY_ICONS: Record<DocumentCategory, React.ComponentType<{ className?: string }>> = {
  [DocumentCategory.PDF]: FileIcon,
  [DocumentCategory.IMAGE]: ImageIcon,
  [DocumentCategory.EMAIL]: MailIcon,
  [DocumentCategory.OTHER]: FileIcon,
};

export interface IDocumentTileProps {
  document: Pick<IViewerDocument, 'mimeType' | 'previewUrl'>;
  className?: string;
}

/**
 * A document's 40px square tile: its preview thumbnail in a bordered box when
 * the API rendered one, otherwise the bare glyph for its category — with the
 * red "PDF" label Figma puts on a PDF's page.
 */
const DocumentTile = ({ document, className }: IDocumentTileProps) => {
  if (document.previewUrl) {
    return (
      <img
        src={document.previewUrl}
        alt=""
        className={cx('border-secondary size-10 shrink-0 rounded-sm border object-cover', className)}
      />
    );
  }

  const category = getDocumentCategory(document.mimeType);
  const Icon = CATEGORY_ICONS[category];

  return (
    <div className={cx('relative flex size-10 shrink-0 items-center justify-center', className)}>
      <Icon className="text-quaternary size-8 shrink-0" />
      {category === DocumentCategory.PDF && (
        <span className="bg-error-600 absolute bottom-1 left-0.5 rounded-[1.6px] px-0.5 text-[8px] font-bold leading-[10px] text-white">
          PDF
        </span>
      )}
    </div>
  );
};

export default DocumentTile;
